import React, { useEffect } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { Button, Grid, IconButton, TextField } from "@mui/material";
import { Add, Close } from "@mui/icons-material";

interface AnswerFieldsProps {
    prefix?: string;
}

export default function AnswerFields({ prefix }: AnswerFieldsProps) {
    const methods = useFormContext();
    const { control } = methods;
    const { fields, append, remove } = useFieldArray({
        control,
        name: `${prefix}correct_answer`,
    })

    const onAddAnswer = () => append({ answer: "" });

    const onRemoveAnswer = (index: number) => remove(index);

    return (
        <>
            {fields.map((field, i) => (
                <Grid key={field.id} container item alignItems={"center"} wrap={"nowrap"}>
                    <Grid item lg={4} xs={12}>
                        <Controller
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    label={`Вариант ответа №${i + 1}`}
                                    variant="outlined"
                                    size="small"
                                    margin={"normal"}
                                    fullWidth
                                />
                            )}
                            control={control}
                            name={`${prefix}correct_answer.${i}.answer`}
                            defaultValue={""}
                        />
                    </Grid>
                    <Grid item sx={theme => ({ paddingLeft: theme.spacing(2) })}>
                        <IconButton disabled={fields.length < 2} onClick={() => onRemoveAnswer(i)}>
                            <Close/>
                        </IconButton>
                    </Grid>
                </Grid>
            ))}
            <Button
                variant={"text"}
                size={"small"}
                endIcon={<Add fontSize={"small"}/>}
                onClick={onAddAnswer}
            >
                Добавить вариант ответа
            </Button>
        </>
    )
}